export default "__VITE_ASSET__BKGdHmn9__"